import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Dialog from '../join/sessionUpdateJoinDialog.component';
import {connect} from 'react-redux';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
  progress: {
    margin: '0 auto',
    width: '100%'
  },
});

const UpdateJoinFileButton = ({
  editFilename,
  classes,
  disabled,
  onExport,
}) => {
  const [ open, setOpen ] = React.useState(false);
  const [ nameEmpty, setNameEmpty ] = React.useState(true);
  const [ isLoading, setIsLoading ] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleNameChange(event) {
    setNameEmpty(event.target.value === '');
    editFilename(event);
  }

  function handleExport() {
    onExport();
    setIsLoading(true);
  }

  return (
    <React.Fragment>
      <Button onClick={handleClickOpen} color="primary" disabled={disabled}>
        <Icon className={classes.icon}>file_copy</Icon>
        Export to new file
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">

    </Dialog>
  </React.Fragment>
)};

UpdateJoinFileButton.propTypes = {
  editFilename: PropTypes.func,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  disabled: PropTypes.bool,
  onExport: PropTypes.func,
  sessionId: PropTypes.string,
  fileId: PropTypes.string,
};

export default withStyles(styles)(UpdateJoinFileButton);
